// extracted by mini-css-extract-plugin
module.exports = {"relatedProducts":"RelatedProducts_relatedProducts__MZ89d","title":"RelatedProducts_title__xQs0k"};